module.exports = __webpack_public_path__ + "static/media/paint8.0c08a365.jpg";